<template lang="html">
    <el-dialog :visible.sync="visible" :title="title" :close='handleClose' ref='amapviewer' width='1200px'>
        <div class="e2e-amap-container-warpper" >
            <div class="e2e-amap-container" v-loading="loading" ref='mapContainer'>
                <div class="search-container">
                    <div class="search-item">
                        <el-input
                            v-model="keyword"
                            :placeholder="$t('system.input.fill_prefix') + $t('component.mapbox.location')"
                            @input="this.onSearchChange"
                            ref="mapSearch"
                            :autofocus="true"
                            prefix-icon="el-icon-search"/>
                    </div>
                    <div class="search-result-warpper">
                        <div class="search-result-container" v-loading="loadingResult" :style="{'height': loadingResult ? '80px' : ''}">
                            <div
                                class="result-warpper"
                                v-for="(item, index) in pois"
                                :key="index"
                                @click="handleSearchResultClick(item, index)"
                            >
                                <div
                                    class="result-item"
                                >
                                    {{item.name}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="address-container">
                    <el-input
                        v-model="address"
                        placeholder=""
                        ref="address"
                        :clearable="true"
                        :disabled="true"
                    >
                        <template slot="append"><span class="btn-clear" @click="clearAddress">{{$t('btn.clear')}}</span></template>
                    </el-input>
                </div>
            </div>

            <div style="padding-top: 24px;text-align: center;">
                <el-button @click.native="handleCancle" plain>{{ $t('btn.cancel') }}</el-button>
                <el-button @click.native="handleConfirm" :disabled="disabled" type="primary" style="margin-left: 200px;">{{ $t('btn.confirm') }}</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader';
import _ from 'lodash';
const MARKER_PREFIX = 'marker_';
import global from '@/global/global';

export default {
  data() {
    return {
      keyword: '',
      address: '', // 当前地址
      map: undefined,
      aMap: undefined,
      //   key: '4660673a7aff6e995fec5bcc74caf03a',
      key: global.AMAP_KEY,
      loading: true,
      markers: [], // 地图标记物
      pickMarker: undefined, // 点击的 marker
      pois: [], // 关键字search 的result列表
      searchTimer: undefined, // 计时器,用于用户输入后 固定事件间隔开始搜索
      loadingResult: false, // 是否正在根据用户输入进行搜索
      marker_green: require('@/assets/map/marker/marker-default.png'),
      marker_red: require('@/assets/map/marker/marker-red.png'),
      markerZIndex: 20,
      targetMarker: undefined, // 当前显示的marker
      visible: true
    };
  },
  props: {
    mode: {
      type: String, // ['search','pick'], search 为搜索模块，pick 为在地图上点击模式
      default: 'search'
    },
    lnglat: {
      type: Array // [经度,纬度]
    },
    location: {
      type: String // 地址
    },
    title: {
      type: String // dialog title
    },
    confirm: {
      type: Function,
      require: true
    },
    confirmMsg: {
      type: String
    }
  },
  methods: {
    loadMap() {
      AMapLoader.load({
        'key': this.key, // 申请好的Web端开发者Key，首次调用 load 时必填
        'version': '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        'plugins': ['AMap.PlaceSearch', 'AMap.Geocoder'] // 插件列表
      }).then((AMap) => {
        this.aMap = AMap;
        this.map = new AMap.Map(this.$refs.mapContainer);
        this.loading = false;
        this.$refs.mapSearch.focus();
        // 注册地图事件
        this.registerMapEvent();
        // 如果传参过来了就初始化地图数据
        this.initMapData();
      }).catch(err => {
        this.$message.error(this.$t('component.mapbox.load_map_error'));
      });
    },
    // 注册地图事件
    registerMapEvent() {
      const that = this;
      if (this.mode.indexOf('pick') > -1) {
        this.map.setDefaultCursor('pointer');
        this.map.on('click', function(ev) {
          that.handleMapClick(ev);
        });
      }
    },
    // 地图点击事件
    async handleMapClick(ev) {
      // 获取点击位置的名称信息
      const [err, address] = await this.$awaitWrap(this.searchByPoint(ev));
      if (address) {
      // 添加点击的marker
        const marker = new this.aMap.Marker({
          icon: this.marker_red,
          anchor: 'bottom-center',
          position: ev.lnglat, // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
          title: address,
          extData: {
            id: MARKER_PREFIX + 'pick',
            address: address,
            search: false
          }
        });
        this.pickMarker = marker;
        this.updateCurrentMarker(marker);
      }
    },
    // 更新最新标记的marker
    updateCurrentMarker(marker) {
      // 如果当前已经有 目标 marker，search 回来的更新icon，pick 的删除
      const targetMarker = this.targetMarker;
      if (targetMarker) {
        const extData = targetMarker.getExtData();
        if (extData.search) {
          this.updateTargetMarkerIcon(targetMarker, this.marker_green);
        } else {
          this.map.remove(targetMarker);
        }
      }
      // 添加新的marker
      this.addMarker(marker);
      const currentExtData = marker.getExtData();
      this.address = currentExtData.address;
      if (currentExtData.search) {
        // 设置当前icon 为 红色
        this.updateTargetMarkerIcon(marker, this.marker_red);
      }
      // 设置新的 marker 为当前的目标marker
      this.targetMarker = marker;
    },
    onSearchChange(value) {
      let waitTime = 600;
      if (this.searchTimer) {
        clearTimeout(this.searchTimer);
      }
      if (value == '') { // 没有值时直接开始搜索
        waitTime = 10;
      }
      this.searchTimer = setTimeout(() => {
        this.clearMap();
        this.searchByKeyword(value);
        clearTimeout(this.searchTimer);
      }, waitTime);
    },
    // 根据地图坐标进行查询具体地址
    async searchByPoint(ev) {
      const geocoder = new this.aMap.Geocoder();
      return new Promise((resolve, reject) => {
        geocoder.getAddress(ev.lnglat, (status, result) => {
          if (status == 'complete') {
            const regeocode = result.regeocode;
            const address = _.get(regeocode, 'formattedAddress');
            resolve(address);
          } else if (status == 'no_data') {
            this.$message.info(this.$t('tip.no_data_found'));
            reject();
          }
        });
      });
    },
    searchByKeyword(keyword) {
      this.loadingResult = true;
      const placeSearch = new this.aMap.PlaceSearch();
      const that = this;
      placeSearch.search(keyword, function(status, result) {
        // 查询成功时，result即对应匹配的POI信息
        if (result.poiList && result.poiList.pois) {
          const pois = result.poiList.pois;
          const markers = [];
          that.loadingResult = false;
          for (let i = 0; i < pois.length; i++) {
            const poi = pois[i];
            const marker = new that.aMap.Marker({
              icon: that.marker_green,
              anchor: 'bottom-center',
              position: poi.location, // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
              title: poi.name,
              extData: {
                id: MARKER_PREFIX + (i + 1),
                address: poi.name,
                search: true
              }
            });
            that.addMarker(marker);
            // 将创建的点标记添加到已有的地图实例：
            markers.push(marker);
          }
          that.pois = pois;
          that.markers = markers;
          that.map.setFitView();
        }
      });
    },
    // 添加地图marker
    addMarker(marker) {
      this.map.add(marker);
      // 注册marker 点击事件
      marker.on('click', this.handleMarkerClick);
    },
    // marker 点击事件
    handleMarkerClick(e) {
      // 设置为 target marker
      this.updateCurrentMarker(e.target);
    },
    // 清除地图覆盖物
    clearMap() {
      if (this.markers.length) {
        this.map.remove(this.markers);
        this.markers = [];
      }
      // 清除pick 的marker
      if (this.pickMarker) {
        this.map.remove(this.pickMarker);
        this.pickMarker = undefined;
      }
      // 清除pick 的marker
      if (this.targetMarker) {
        this.map.remove(this.targetMarker);
      }
    },
    // 点击搜索结果地图缩放到对应位置
    handleSearchResultClick(item, index) {
      this.map.setZoom(15);
      this.map.panTo(item.location);
      this.updateMarkerBySearchIndex(item, index);
    },
    // 根据当前选中项和索引更新 当前的marker
    updateMarkerBySearchIndex(item, index) {
      // 在地图上获取当前地名对应的marker对应
      let targetMarker;
      // 根据index 从当前 marker 列表获取当前电机的 marker
      for (let i = 0; i < this.markers.length; i++) {
        const marker = this.markers[i];
        const extData = marker.getExtData();
        if (extData.id == (MARKER_PREFIX + (index + 1))) {
          targetMarker = marker;
        }
      }
      if (targetMarker) {
        this.updateTargetMarkerIcon(targetMarker, this.marker_red);
        this.updateCurrentMarker(targetMarker);
      }
    },
    // 更新最新使用的 marker
    updateTargetMarkerIcon(marker, icon) {
      marker.setIcon(icon);
      marker.setzIndex(this.markerZIndex++);
    },
    clearAddress() {
      this.clearMap();
      this.keyword = '';
      this.pois = [];
      this.address = '';
      this.targetMarker = undefined;
    },
    hide() {
      this.visible = false;
    },
    handleCancle() {
      this.hide();
    },
    handleConfirm() {
      this.$messageBox({
        icon: 'warning', // --->弹窗类型 非必填 [success √,warning ！,error X]
        severity: 'medium',
        title: this.confirmMsg || this.$t('component.mapbox.default_confirm_title'), // -->副标题 非必填
        btnText: this.$t('btn.confirm'), // -->按钮内文字 非必填,
        callBack: this.confirmAddress
      });
    },
    confirmAddress() {
      const position = this.targetMarker.getPosition();
      const lnglat = [position.lng, position.lat];
      if (this.confirm) {
        this.confirm(lnglat, this.address);
      }
      this.hide();
    },
    initMapData() {
      if (this.lnglat && this.lnglat.length) {
        const lnglat = this.lnglat;
        // 添加该点为初始化 marker
        const marker = new this.aMap.Marker({
          icon: this.marker_red,
          anchor: 'bottom-center',
          position: lnglat, // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
          title: this.location,
          extData: {
            id: MARKER_PREFIX + 'init',
            address: this.location,
            search: false
          }
        });
        this.map.setZoom(15);
        this.map.panTo(lnglat);
        this.updateCurrentMarker(marker);
      }
    },
    handleClose() {

    }
  },
  computed: {
    disabled: function() {
      return !this.address;
    }
  },
  watch: {
    // lnglat(val, oldVal) {
    //   // oldVal 不存在说明是第一个加载
    //   if (this.map) {
    //     this.clearAddress();
    //     if (val && val.length) {
    //       this.initMapData();
    //     }
    //   }
    // },
    mode(val, oldVal) {
      // 模式变化需要更新map 事件
    }
  },
  updated() {

  },
  mounted() {
    this.loadMap();
  },
  destory() {
    // 注销地图事件
  }
};
</script>

<style lang="less" scoped>
.e2e-amap-container{
    height: 500px;
    width: 100%;
    position: relative;
    z-index: 199;

    .search-container{
        position: absolute;
        top: 50px;
        left: 50px;
        width: 280px;
        z-index: 999;
    }

    .address-container{
        position: absolute;
        top: 450px;
        left: 600px;
        width: 400px;
        z-index: 999;

        .btn-clear{
            cursor: pointer;
        }
    }
    .search-result-warpper{
        width: 100%;
        margin-top: 10px;
        background: #ffffff;
        border-radius: 4px;
        .search-result-container{
            overflow: auto;
            max-height: 400px;

            .result-warpper{
                padding-left: 20px;
                padding-right: 20px;

                .result-item{
                    color: @mainColor;
                    padding: 8px 12px;
                    border-bottom: 1px solid @borderOnePx;
                    cursor: pointer;
                    font-size: 14px;
                    line-height: 20px;
                }

                &:hover{
                    background-color: @bgColor;
                }

                &:last-child .result-item{
                    border-bottom: none;
                }

            }


            &::-webkit-scrollbar {
                width: 8px;
                height: 8px;
                background-color: #F1F1F1;
                -webkit-border-radius: 4px;
                -moz-border-radius: 4px;
                border-radius: 4px;
            }


            &::-webkit-scrollbar-thumb {
                cursor: pointer;
                background-color: #cccccc;
                -webkit-border-radius: 4px;
                -moz-border-radius: 4px;
                border-radius: 4px;
                width: 10px;
            }
        }

    }
}
</style>



// WEBPACK FOOTER //
// index.vue?097e2d84